import { render, staticRenderFns } from "./SalesForceCallback.vue?vue&type=template&id=2ab354b4&scoped=true&"
import script from "./SalesForceCallback.vue?vue&type=script&lang=ts&"
export * from "./SalesForceCallback.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ab354b4",
  null
  
)

export default component.exports